import { useEffect, useState } from "react";
import CSDTable from "@cloudscape-design/components-themed/table";
import {
  Box,
  Icon,
  Pagination,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { useGetApplicationFormsQuery } from "../../features/api";
import {
  ApprovalStatusPattern,
  COMMON_LABELS,
  getStatus,
} from "../default-constants";
import { LABELS, LIST_PAGE_SIZE, getUsageSituation } from "./constants";
import { useCollection } from "@cloudscape-design/collection-hooks";

export interface ApplicationForms {
  formTypeNo: number;
  version: String;
  usageEnabledFlag: boolean;
  approvalStatus: number;
  applyingServiceLabel: string;
  formTypeName: string;
  applicationStartDate: string;
  approvalStatusName: string;
}

const columnDefinitions = [
  {
    id: "usageEnableFlag",
    header: LABELS.USAGE_ENABLE_FLAG,
    cell: (e: any) => getUsageSituation(e.usageEnabledFlag),
  },
  {
    id: "approvalStatus",
    header: LABELS.APPROVAL_STATUS,
    cell: (e: any) =>
      e.approvalStatusName ===
      ApprovalStatusPattern.awaitingApproval.statusName ? (
        <>
          <Icon name="flag" variant="warning" />
          {e.approvalStatusName}
        </>
      ) : (
        e.approvalStatusName
      ),
  },
  {
    id: "applyingServiceLabel",
    header: LABELS.APPLYING_SERVICE_LABEL,
    cell: (e: any) => e.applyingServiceLabel,
  },
  {
    id: "formTypeName",
    header: LABELS.FORM_TYPE_NAME,
    cell: (e: any) => e.formTypeName,
  },
  {
    id: "version",
    header: LABELS.VERSION,
    // TODO 申請様式内容登録・更新画面が未実装のためコメントアウト
    // cell: (e: any) => (
    //   <Link to={"/application-form/" + e.formTypeNo + "/" + e.version}>
    //     {e.version}
    //   </Link>
    // ),
    cell: (e: any) => e.version,
  },
  {
    id: "applicationStartDate",
    header: LABELS.APPLYING_START_DATE,
    cell: (e: any) => e.applicationStartDate,
  },
];

/* 
申請様式一覧
 */
const Table = () => {
  // 申請様式一覧API呼び出し
  const { data, isFetching } = useGetApplicationFormsQuery();

  // 一覧ページ数
  const [currentPageIndex, setCurrentPageIndex] = useState(1);

  // 表示用リストに格納
  const listData = data
    ? data.map((item) => ({
        ...item,
        approvalStatusName: getStatus(item.approvalStatus),
      }))
    : [];

  const { items, actions, paginationProps } = useCollection(listData, {
    pagination: { pageSize: LIST_PAGE_SIZE },
  });

  useEffect(() => {
    // 一覧変更ごとにページ切り替え
    setCurrentPageIndex(1);
  }, [data]);

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      loading={isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      items={items}
      resizableColumns
      stickyHeader
      header={
        <SpaceBetween size="xs">
          <SpaceBetween direction="horizontal" size="l">
            {/* <Button
              onClick={() => {
                navigate("/application-form/regist");
              }}
              formAction="none"
            >
              {LABELS.APPLICATION_FORM_REGIST}
            </Button> */}
          </SpaceBetween>
        </SpaceBetween>
      }
      pagination={
        <Pagination
          {...paginationProps}
          currentPageIndex={currentPageIndex}
          onChange={(event) => {
            actions.setCurrentPage(event.detail.currentPageIndex);
            setCurrentPageIndex(event.detail.currentPageIndex);
          }}
        />
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;
